import { 
    Popover,   __experimentalHStack as HStack, __experimentalVStack as VStack,
    __experimentalText as Text,Button,__experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOption as ToggleGroupControlOption} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import {MediaUpload } from '@wordpress/block-editor';
import { useState } from 'react';
import { LuUpload } from "react-icons/lu";

export const Image = ({ popoverAnchor, setIsVisible, frameData, onChange,dataKey, imageUrls, handleBorderImageClick}) => {

    const [isMediaOpen, setIsMediaOpen] = useState(false);

    const handleBorderImagecustomClick = (value) => {
        const updatedAttributes = {
            ...frameData,
            image: {
                ...frameData.image,
                customImage: value,
            },
        };
    
        onChange(dataKey, updatedAttributes);
    };
    
  return (
        <Popover
            placement="left-start"
            className='vayu_blocks_toolspanel_items_popover'
            anchor={popoverAnchor}
            onClose={() => {
                if (!isMediaOpen) setIsVisible(false); // Sirf tab close hoga jab media library open na ho
            }}
            offset={35}
            resize
        >

            <VStack  style={{padding:'10px',width: '280px'}}>

                <Text>
                    <h4>{__('Border Image','vayu-blocks')}</h4>
                    <p>{__('Select a border image for your element.','vayu-blocks')}</p>
                </Text>

                <Text>

                    <ToggleGroupControl
                            className="togglegroupcontrol-vayu-blcoks-image-border-frame"
                            __next40pxDefaultSize
                            __nextHasNoMarginBottom
                            isBlock
                            value={ frameData.image.type }
                            onChange={(value) => {
                                const updatedAttributes = {
                                    ...frameData,
                                    image: {
                                        ...frameData?.image,
                                        type: value,
                                    },
                                };
                            
                                onChange(dataKey, updatedAttributes);
                            }}
                            
                            >
                            <ToggleGroupControlOption
                                label= {__('Space','vayu-blocks')} 
                                value="space"
                            />
                            <ToggleGroupControlOption
                                label={__('Stretch','vayu-blocks')}
                                value="stretch"
                            />
                            <ToggleGroupControlOption
                                label={__('Repeat','vayu-blocks')}
                                value="repeat"
                            />
                            <ToggleGroupControlOption
                                label={__('Round','vayu-blocks')}
                                value="round"
                            />
                    </ToggleGroupControl>

                </Text>

                <Text>
                    <HStack  spacing="2" wrap={true} justify="flex-start">

                    {Object.entries(imageUrls).map(([key, url]) => (
                        <>
                            {key === 'none' ? (
                                <Text
                                key={key}
                                className={`vayu-blocks-ihover-main-panel  ${!frameData?.image?.url || frameData?.image?.url === url ? 'none-selected' : ''}`}
                                onClick={() => handleBorderImageClick(url)}
                                title={key}
                                >
                                <div style={{ margin: '3px 8px' }} className={`vayu-blocks-panel-ihover vayu-blocks-none-button vayu_blocks_${key}`} ></div>
                                </Text>
                            ) : (
                                <Text
                                key={key}
                                className={`vayu-blocks-ihover-main-panel ${frameData?.image?.url === url ? 'vayu-blcoks-image-border-selected' : ''}`}
                                onClick={() => handleBorderImageClick(url)}
                                title={key}
                                >
                                {url !== "custom" ? (
                                    <img 
                                        style={{background:'none'}}
                                        src={url} 
                                        alt={key} 
                                        width="55" 
                                        height="50" 
                                        className="vayu-blocks-panel-ihover  height-upgrade-effect-animation vayu-border-image-preview" 
                                    />
                                ) : (
                                    frameData.image.customImage != "" ? (
                                        <>
                                            <div 
                                                style={{ position: 'relative', width: '55px', height: '50px' , background: 'none'}} 
                                                className="vayu-blocks-panel-ihover  height-upgrade-effect-animation vayu-border-image-preview-container"
                                            >
                                                {/* Image */}
                                                <img 
                                                    src={frameData.image.customImage}  
                                                    alt="Custom Image" 
                                                    width="55" 
                                                    height="50" 
                                                    className=" height-upgrade-effect-animation vayu-border-image-preview" 
                                                />

                                                    <Button 
                                                        isDestructive
                                                        variant="primary"
                                                        className="clear-image-button vayu-blcoks-desctructive-image-border"
                                                        isSmall
                                                        onClick={() => {
                                                            const tempValue = {
                                                                ...frameData,
                                                                image: { ...frameData.image, customImage: 'temp' }
                                                            };
                                                        
                                                            onChange(dataKey, tempValue); // Step 1: Set temporary value
                                                        
                                                            setTimeout(() => {
                                                                const clearedValue = {
                                                                    ...frameData,
                                                                    image: { ...frameData.image, customImage: '' }
                                                                };
                                                                onChange(dataKey, clearedValue); // Step 2: Reset it to empty
                                                            }, 50);
                                                        }}
                                                        
                                                        
                                                    >
                                                        ✖
                                                    </Button>

                                                {/* Replace Image (Visible on Hover) */}
                                                <div 
                                                    className="replace-image-overlay"   
                                                >
                                                    <LuUpload onClick={() => setIsMediaOpen(true)}/>
                                                </div>
                                            </div>

                                            {/* Media Upload */}
                                            {isMediaOpen && (
                                                <MediaUpload
                                                    onSelect={(media) => {
                                                        handleBorderImagecustomClick(media.url);
                                                        setIsMediaOpen(false);
                                                    }} 
                                                    allowedTypes={['image']}
                                                    render={({ open }) => open()}
                                                    onClose={() => setIsMediaOpen(false)}
                                                />
                                            )}
                                        </>

                                    ) : (
                                        <MediaUpload
                                            onClose={() => setIsMediaOpen(false)}
                                            onSelect={(media) => {
                                                handleBorderImagecustomClick(media.url);
                                                setIsMediaOpen(false); // Media select hone ke baad normal state par wapas
                                            }} 
                                            allowedTypes={['image']}
                                            render={({ open }) => (
                                                <div 
                                                    style={{ margin: '3px 8px', cursor: 'pointer',fontSize: '26px' }} 
                                                    className="vayu-blocks-panel-ihover vayu-blcoks-panel-image-frame height-upgrade-effect-animation"
                                                    onClick={() => {
                                                        setIsMediaOpen(true);
                                                        open();
                                                    }}
                                                >
                                                    <LuUpload />
                                                </div>
                                            )}
                                        />
                                    )
                                )}

                                </Text>
                            )}
                        </>
                    ))}

                    </HStack>

                </Text>

            </VStack>
            
        </Popover>
  )
}
